import * as types from '../event_types'
import * as restlet from '../actions/rest'
import Vue from 'vue';
import Cookies from 'js-cookie';
// STATE

const state = {
  user: {}
}

// GETTERS

const getters = {
  user: s => s.user
}

// ACTIONS

const actions = {
  signOut() {
    window.location = process.env.VUE_APP_LOGOUT_URI
  },
  async fetchUser({ state, commit }) {
    if (Cookies.get('token')) {
      if (state.user.email) {
        return new Promise(resolve => resolve(state.user))
      } else {
        return restlet.getLoggedInUser().then(function (response) {
          if (response.status === 200) {
            commit(types.SET_USER, response.data.data)
            return response.data.data
          } else {
            return undefined
          }
        })
      }
    } else {
      let current = window.location
      window.location = process.env.VUE_APP_LOGIN_URI + "?state=" + current
    }
  }
}

// MUTATIONS

/* eslint no-param-reassign:
["error", { "props": false}] */

const mutations = {
  setUser(s, user) {
    Vue.set(s, 'user', user)
  }
}

// EXPORT

export default {
  state,
  getters,
  actions,
  mutations
}
